export const getReleaseNotesMarkdown = (releaseNotes: any): string => {
  if (!releaseNotes) {
    return "";
  }
  if (typeof releaseNotes === "string") {
    return releaseNotes;
  }
  if (typeof releaseNotes === "object") {
    if (typeof releaseNotes.markdown === "string") {
      return releaseNotes.markdown;
    }
    if (typeof releaseNotes.text === "string") {
      return releaseNotes.text;
    }
    if (typeof releaseNotes.content === "string") {
      return releaseNotes.content;
    }
    if (typeof releaseNotes.en === "string") {
      return releaseNotes.en;
    }
    const firstString = Object.values(releaseNotes).find(
      (value) => typeof value === "string"
    );
    return typeof firstString === "string" ? firstString : "";
  }
  return "";
};

export const toReleaseNotesPayload = (markdown: string): { markdown: string } => ({
  markdown: String(markdown || ""),
});

export const hasReleaseNotes = (releaseNotes: any): boolean =>
  getReleaseNotesMarkdown(releaseNotes).trim().length > 0;
